const textos = {
    alteracaoHorario:'Ao alterar horário de funcionamento, verifique a assistência farmacêutica para a atividade.',
    presencaRT:'É necessário que a empresa apresente junto ao CRF/RS um farmacêutico RT!',
    maisDeUmRT: "É permitido que a empresa apresente junto ao CRF/RS somente um farmacêutico RT.",
    nenhumHorario : "Verifique se os profissionais que não trabalham por escala possuem horário preenchido"
}

export default textos;